import { ImageAnnotationRecord } from "models/view-models/block-configurations/image-annotation-record";
import { ConfirmationModal } from "molecules/modals/confirmation-modal";
import ImageAnnotationListItem from "organisms/image-annotations/image-annotation-list-item";
import ImageAnnotationsModal from "organisms/image-annotations/image-annotations-modal";
import React, { useState } from "react";
import useImageAnnotations from "utilities/hooks/domain/notebooks/pages/use-image-annotations";
import useModalActions from "utilities/hooks/use-modal-actions";
import { t } from "utilities/localization-utils";

export const IMAGE_ANNOTATION_LIST_CSS_CLASS_NAME = "c-image-annotation-list";

interface ImageAnnotationListProps {
    imageAnnotations: ImageAnnotationRecord[];
    onUpdated?: (
        imageAnnotation: ImageAnnotationRecord | null | undefined
    ) => Promise<void>;
    onDeleted?: (
        imageAnnotation: ImageAnnotationRecord | null | undefined
    ) => Promise<void>;
    isEditable?: boolean;
}
const ImageAnnotationList = (props: ImageAnnotationListProps) => {
    const { imageAnnotations, onUpdated, isEditable, onDeleted } = props;
    const [activeImageAnnotation, setActiveImageAnnotation] =
        useState<ImageAnnotationRecord>();
    const { handleOpen, handleClose, isOpen } = useModalActions();
    const {
        handleOpen: handleDeleteOpen,
        handleClose: handleDeleteClose,
        isOpen: isDeleteOpen,
    } = useModalActions();

    const { deleteImageAnnotation } = useImageAnnotations();
    const handleEditClick = (imageAnnotationToEdit: ImageAnnotationRecord) => {
        setActiveImageAnnotation(imageAnnotationToEdit);
        handleOpen();
    };
    const handleDeleteClick = (imageAnnotationToDelete) => {
        setActiveImageAnnotation(imageAnnotationToDelete);
        handleDeleteOpen();
    };
    const handleDeleteAnnotation = async () => {
        if (!activeImageAnnotation) {
            return;
        }
        await deleteImageAnnotation(activeImageAnnotation);
        handleDeleteClose();
        onDeleted && onDeleted(activeImageAnnotation);
    };

    const activeImageAnnotationNumber =
        imageAnnotations.findIndex(
            (ia) => ia.id === activeImageAnnotation?.id
        ) + 1;

    return (
        <>
            <ol className={IMAGE_ANNOTATION_LIST_CSS_CLASS_NAME}>
                {imageAnnotations.map((ia, index) => (
                    <ImageAnnotationListItem
                        number={index + 1}
                        key={ia.id}
                        isEditable={isEditable}
                        imageAnnotation={ia}
                        onEdit={handleEditClick}
                        onDelete={handleDeleteClick}
                    />
                ))}
            </ol>
            <ImageAnnotationsModal
                number={activeImageAnnotationNumber}
                imageAnnotation={activeImageAnnotation}
                isVisible={isOpen}
                onCancel={handleClose}
                onClose={handleClose}
                onSubmit={onUpdated}
            />
            <ConfirmationModal
                label={t("areYouSure")}
                isVisible={isDeleteOpen}
                message={t("confirmationMessage", {
                    action: t("delete").toLowerCase(),
                    item: t("annotation").toLowerCase(),
                })}
                onCancel={handleDeleteClose}
                onConfirm={handleDeleteAnnotation}
            />
        </>
    );
};

export default ImageAnnotationList;
